import { getComplaintManageList } from '@/api/domain/orders'
import { useDictParseList } from '@/utils/useUtils'

const HANDLE_COMPLAINT_STATUS = {
  WAIT_PROCESS: 100,
  PROCESSING: 200,
  PROCESSED: 300,
}

const handleComplaintList = {
  [HANDLE_COMPLAINT_STATUS.WAIT_PROCESS]: '待处理',
  [HANDLE_COMPLAINT_STATUS.PROCESSING]: '处理中',
  [HANDLE_COMPLAINT_STATUS.PROCESSED]: '已处理',
}


const getConfigData = (vm,
  handleProcessComplaint,
  showResultDialog,
  showPhoneNumberDialog,
  state) => {
  const formDataConfig = {
    formData: {
      formProps: {
        model: { state: HANDLE_COMPLAINT_STATUS.WAIT_PROCESS },
      },
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '司机姓名',
            prop: 'driverName',
          },
          elConfig: {
            maxLength: 50,
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '订单ID',
            prop: 'orderNo',
          },
          elConfig: {
            maxLength: 50,
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
        },
        {
          el: 'select',
          itemConfig: {
            label: '处理状态',
            prop: 'state',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: useDictParseList(handleComplaintList, true),
            },
          },
        },
      ],
    },
    tableData: {
      columns: [
        {
          name: 'complainantUserName',
          columnProps: {
            prop: 'complainantUserName',
            label: '司机姓名',
          },
        },
        {
          name: 'tel',
          columnProps: {
            prop: 'tel',
            label: '联系电话',
            width: 150,
          },
          render: ({ row }) => {
            return vm.$createElement('div', {}, [
              vm.$createElement('span', {}, row.tel),
              vm.$createElement('el-button', {
                attrs: {
                  type: 'text',
                },
                on: {
                  click: () => showPhoneNumberDialog(row),
                },
              }, '查看'),
            ])
          },
        },
        {
          name: 'orderNo',
          columnProps: {
            prop: 'orderNo',
            label: '订单ID',
          },
          render: ({ row }) => {
            if (!row.orderNo) {
              return '--'
            }
            return vm.$createElement('el-link', {
              props: {
                type: 'primary',
                underline: false,
                href: `/workbench/rentOrder/detail?id=${row.orderNo}&orderType=personal`,
              },
              attrs: {
                target: '_blank',
              },
            }, row.orderNo)
          },
        },
        {
          name: 'carPlateNo',
          columnProps: {
            prop: 'carPlateNo',
            label: '车牌号',
          },
        },
        {
          name: 'factAmount',
          columnProps: {
            prop: 'factAmount',
            label: '申诉金额',
          },
        },
        {
          name: 'payMethod',
          columnProps: {
            prop: 'payMethod',
            label: '支付方式',
          },
        },
        {
          name: 'reason',
          columnProps: {
            prop: 'reason',
            label: '申诉原因',
          },
        },
        {
          name: 'description',
          columnProps: {
            prop: 'description',
            label: '申诉说明',
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '申诉时间',
          },
        },
        {
          name: 'result',
          columnProps: {
            prop: 'result',
            label: '处理意见',
          },
          render: ({ row }) => {
            if (!row.result) {
              return '--'
            }
            const truncateString = row.result.length > 10 ? `${row.result.substring(0, 10)}...` : row.result
            return vm.$createElement('div', {}, [
              vm.$createElement('span', {}, truncateString),
              vm.$createElement('el-button', {
                attrs: {
                  type: 'text',
                },
                on: {
                  click: () => showResultDialog(row),
                },
              }, '查看'),
            ])
          },
        },
        {
          name: 'processorUserName',
          columnProps: {
            prop: 'processorUserName',
            label: '处理人',
          },
        },
        {
          name: 'gmtModified',
          columnProps: {
            prop: 'gmtModified',
            label: '处理时间',
          },
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '处理状态',
          },
          getText: ({ row }) => handleComplaintList[row.state],
        },
        {
          name: 'operate',
          type: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
          },
          getOperateList: ({ row }) => {
            const btnList = []

            if (row.state === HANDLE_COMPLAINT_STATUS.WAIT_PROCESS) {
              btnList.push({
                label: '去处理',
                action: () => handleProcessComplaint('handle', row),
              })
            } else {
              btnList.push({
                label: '更新进展',
                action: () => handleProcessComplaint('update', row),
              })
            }

            return btnList
          },
        },
      ],
      apiFn: getComplaintManageList,
    },
    isShowDepartment: false,
  }

  if (state) {
    formDataConfig.formData.formProps.model.state = Number(state)
  }

  return formDataConfig
}

export { getConfigData, HANDLE_COMPLAINT_STATUS, handleComplaintList }

